// src/models/pedidos/StatusPedido.js
export const StatusPedido = Object.freeze({
  Cancelado: 1,
  EmAnalise: 2,
  EmProducao: 3,
  AguardandoRetiradaEntrega: 4,
  Concluido: 5,
});

export const StatusPedidoDescricao = Object.freeze({
  [StatusPedido.Cancelado]: 'Cancelado',
  [StatusPedido.EmAnalise]: 'Em análise',
  [StatusPedido.EmProducao]: 'Em Produção',
  [StatusPedido.AguardandoRetiradaEntrega]: 'Aguardando Retirada/Entrega',
  [StatusPedido.Concluido]: 'Concluído',
});

export const getStatusPedidoDescricao = (statusPedido) => {
  if (statusPedido && typeof statusPedido === 'object') {
    return statusPedido.descricao || statusPedido.descricaoStatus || statusPedido.statusPedidoDescricao || '';
  }

  return StatusPedidoDescricao[Number(statusPedido)] || '';
};

export const statusPedidoOptions = Object.entries(StatusPedidoDescricao).map(([value, label]) => ({
  value: Number(value),
  label,
}));